/**
 * IMPORTS
 */
import {ApplicationError} from 'src/aggregates/err/applicationerror';


/**
 * CODE
 */

/**
 * I am a file upload error.
 */
class FileUploadError extends ApplicationError
{
}


/**
 * EXPORTS
 */
export {
    FileUploadError,
};
